// extracted by mini-css-extract-plugin
module.exports = {"section":"Home_section__1uiwC"};